/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Atv1EnabledSettingParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ATV1_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class Atv1EnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Atv1EnabledSettingParser.decode(input).map(res => new Atv1EnabledSetting(res));
    }
    static unsafeDecode(input) {
        return Atv1EnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Atv1EnabledSettingParser.encode(data);
    }
    static schema() {
        return Atv1EnabledSettingParser.schema();
    }
}
